export const GET_BANNER = `/api/v1/user/banner/get`;
export const GET_406 = `/api/v1/user/406`;
